<template>
  <div class="consider__plan__form">
    <div class="text-center mb-4">
      <div class="font-32 font-w-700 font-ch">
        {{this.$route.query.formType === "area-form" ? "แบบฟอร์มพิจารณา" : "แบบฟอร์มพิจารณาแผนงาน"}}

      </div>
      <div class="font-20 font-w-700 font-ch" stylec="color: #f7941d">
        (Consider Form)
      </div>
    </div>

    <div class="text-center font-20 font-w-500 font-ch px-16 mb-6" v-if="fiscalYear">
      {{(this.$route.params.formType === "area-form" ? "เกณฑ์การพิจารณาแบบฟอร์มคำร้องขอใช้พื้นที่" : getNameFromPlanCode()) + " ประจำปีงบประมาณ " + fiscalYear}}
    </div>
    <v-card flat class="pa-6 section_form mb-3">
      <v-layout align-center class="font-14 font-w-500 font-ch">
        <v-flex shrink>
          <span class="mr-2">รหัสแผนงาน</span>
          <span class="text__orange">{{ form.plan_code }}</span>
        </v-flex>
        <v-flex shrink class="mx-12">
          <span class="text__orange">
            {{ form.plan_region }}
          </span>
        </v-flex>
        <v-flex shrink>
          <span>
            <span class="mr-2">ผู้พิจารณา</span>
            <span class="text__orange">{{ form.evaluator_name }}</span>
          </span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink>
          <span>
            <span class="mr-2">วันที่</span>
            <span class="text__orange">{{ date }}</span>
          </span>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Table -->
    <v-card flat class="pa-4 section_form mb-3">
      <table class="custom_table">
        <thead>
          <tr class="pa-2">
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="5%"
            >
              ลำดับ
            </th>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="70%"
            >
              ประเภท/รายละเอียด
            </th>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="10%"
            >
              คะเเนนเต็ม
            </th>
            <th class="text-center font-12" width="25%">ผลการประเมิน</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in form.details"
            :key="i"
            style="vertical-align: top"
          >
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              {{ i + 1 }}.
            </td>
            <td
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="70%"
              class="py-3"
            >
              <div>
                <!-- main detail -->
                <div style="height: 35px">
                  {{ item.plan_name }}
                </div>
                <!-- sub detail -->
                <div
                  style="height: 50px"
                  class="d-flex align-center"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                >
                  <div>
                    <span class="mr-2">{{ i + 1 }}.{{ j + 1 }}</span>
                    <span>{{ sub.name }}</span>
                  </div>
                </div>
              </div>
            </td>
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="10%"
            >
              <div>
                <!-- main detail -->
                <div class="text__orange" style="height: 35px">
                  {{ item.max_score }}
                </div>
                <!-- sub detail -->
                <div
                  style="height: 50px"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="d-flex align-center justify-center"
                >
                  <span>{{ sub.max_score }}</span>
                </div>
              </div>
            </td>
            <td
              class="text-center py-3"
              width="25%"
              style="border-bottom: 1px solid #d3d3d3"
            >
              <div>
                <!-- main detail -->
                <div style="height: 35px">
                  {{ item.sub_details.length == 0 ? item.score : "" }}
                </div>
                <!-- sub detail -->
                <div
                  style="height: 50px"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="d-flex align-center justify-center"
                >
                  {{ sub.score }}
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td style="border-right: thin solid #d3d3d3"></td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              <span class="mr-2">คะแนนรวม</span>
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              <span class="text__orange">{{ form.overall_score }}</span>
            </td>
            <td class="text-center">
              <span class="text__orange">{{ form.total_score }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <!--  ความคิดเห็น/ข้อเสนอเเนะ -->
    <v-card flat class="pa-4 section_form mb-3">
      <div class="font-14 font-w-500 font-ch mb-2">ความคิดเห็น/ข้อเสนอเเนะ</div>
      <v-textarea
        v-model="form.feedback"
        outlined
        readonly
        dense
        rows="5"
        color="#D3D3D3"
        style="border-radius: 30px"
      ></v-textarea>
    </v-card>

    <!-- <div class="font-14 font-w-500 font-ch mb-5" style="color: #f15a29">
      หมายเหตุ : แบบประเมินหากทำการลงคะเเนนแล้วไม่สามารถแก้ไขได้
    </div> -->
  </div>
</template>

<script>
import Service from "../../services";
import { Icon } from "@iconify/vue2";
import moment from "moment";

export default {
  name: "EvaluateView",
  components: {
    Icon,
  },
  data() {
    return {
      date: moment().add(543, "year").format("DD/MM/YYYY"),
      valid: true,
      loadingBtn: false,
      dialog: false,
      dialogMsg: "บันทึกสำเร็จ",
      fiscalYear: null,
      form: {
        layout_id: null,
        plan_id: null,
        form_b_id: null,
        plan_code: null,
        plan_region: null,
        evaluator_id: null,
        evaluator_name: null,
        evaluate_date: moment().format("YYYY-MM-DD"),
        overall_score: 0,
        total_score: 0,
        feedback: null,
        details: [],
      },
    };
  },
  computed: {
    user: function () {
      return this.$store.state.Auth.User;
    },
  },
  created() {
    this.fetchForm();
  },

  methods: {
    fetchForm() {
      Service.Consider.getEvaluateView(this.$route.params.id).then((res) => {
        const { data } = res;
        console.log("fetchForm", data);
        const formData = data?.data;
        // set data to form
        this.fiscalYear = formData?.form_b?.fiscal_year || formData?.area_form?.year || null;
        this.form.plan_code = formData?.plan_code;
        this.form.plan_region = formData?.plan_region;
        this.form.evaluator_name = formData?.evaluator_name;
        this.form.evaluate_date = moment(formData.evaluate_date)
          .add(543, "year")
          .format("DD/MM/YYYY");
        this.form.overall_score = formData?.overall_score;
        this.form.total_score = formData?.total_score;
        this.form.feedback = formData?.feedback;
        this.form.details = formData?.details.map((item) => {
          return {
            plan_name: item.plan_name,
            max_score: item.max_score,
            score: item.score,
            sub_details: item.sub_details.map((sub) => {
              return {
                name: sub.name,
                max_score: sub.max_score,
                score: sub.score,
              };
            }),
          };
        });
      });
    },
    getNameFromPlanCode() {
      switch(this.form.plan_code) {
        case 'IRTC':
          return 'แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)';
        case 'STI':
          return 'แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์ เทคโนโลยีและนวัตกรรม (STI)';
        case 'SP':
          return 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ (SP)';
        case 'CR':
          return 'แผนงานวิจัยร่วมกับภาคเอกชน (CR)';
        case 'RSPM':
          return 'แผนงาน RSP Management';
        case 'AREA':
          return 'แผนงานบริหารจัดการอาคาร';
        default:
          return 'แบบฟอร์มไม่รู้จัก';
      }
    }
  },
};
</script>

<style lang="scss">
.consider__plan__form {
  .section_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px;
  }
  .text__orange {
    color: #f15a29;
  }
  .custom_table {
    border: thin solid #d3d3d3;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
  .btn_orange_gradient {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
  .v-text-field__slot {
    input {
      text-align: center !important;
    }
  }
  .custom_table {
    border-spacing: 0px;
    width: 100%;
    th {
      padding: 10px;
      border-bottom: 1px solid #d3d3d3;
    }
    td {
      padding: 10px;
    }
  }
}
</style>
